import React from 'react';
import { CTAButton } from '../CTAButton';
import { CountdownTimer } from '../CountdownTimer';
import { ScarcityBar } from '../ScarcityBar';
const badges = ['Instant Download', 'One-Time Payment', 'Lifetime Access', '7-Day Guarantee'];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-navy-950 px-4 pb-12 pt-8 sm:px-6 sm:pb-16 sm:pt-12" data-id="element-150" data-mp="huo1e2ebseqg">
      <div aria-hidden="true" className="pointer-events-none absolute inset-x-0 top-0 h-1.5 bg-gold-500" data-id="element-151" data-mp="muk5s2qxq86j" />
      <div className="mx-auto w-full max-w-3xl" data-id="element-152" data-mp="qub3yrisjql3">
        <p className="text-center font-display text-[15px] font-bold uppercase tracking-[0.14em] text-gold-500 sm:text-lg" data-id="element-153" data-mp="vmcarxx6wp3q">
          🔧 Technical System PRO 360™
        </p>

        <h1 className="mt-3 text-center font-display text-[34px] font-extrabold uppercase leading-[0.98] text-white sm:text-[56px]" data-id="element-154" data-mp="10njk41ezdwci">
          Build a professional appliance repair business in{' '}
          <span className="text-gold-500" data-id="element-155" data-mp="1ahij4rjrd008">just one day</span>
        </h1>

        <p className="mx-auto mt-3 max-w-xl text-center text-[15px] font-medium text-white/70 sm:text-lg" data-id="element-156" data-mp="9olxc8cunwmu">
          Even if you still have only a few customers.
        </p>

        <div className="mt-6 flex justify-center" data-id="element-157" data-mp="3vu9499yc40fq">
          <img src="https://cdn.magicpatterns.com/uploads/aMbBWv5rmcu4mMwStXQ2oo/SOLDADURA-IT.png" alt="Technical System PRO 360 digital product box with 300+ templates, processes and tools" className="w-full max-w-[300px] drop-shadow-[0_20px_40px_rgba(0,0,0,0.55)] sm:max-w-[380px]" data-id="element-158" data-mp="3vx3p32l9fn9o" />
        </div>

        <p className="mx-auto mt-6 max-w-2xl text-center text-[15px] leading-relaxed text-white/85 sm:text-lg" data-id="element-159" data-mp="inpirizhoo4i">
          Get <strong className="text-white" data-id="element-160" data-mp="em49s8q2stzl">300+ ready-to-use templates</strong>
          , processes, protocols and business tools designed to help appliance
          repair technicians charge with confidence, organize their workshop and
          operate like a true professional from the very first service.
        </p>

        <p className="mx-auto mt-3 max-w-2xl text-center text-[14px] font-semibold text-gold-400 sm:text-base" data-id="element-161" data-mp="30mparp8cqgp3">
          The complete business operating system for appliance repair
          technicians.
        </p>

        <div className="mt-7" data-id="element-162" data-mp="2qu9t6t0yvu4q">
          <CTAButton id="hero-cta" label="I want the Technical System PRO 360™" sub="Instant Download · One-Time Payment · Lifetime Access · 7-Day Guarantee" data-id="element-163" data-mp="2vup3fbpyclih" />
        </div>

        <div className="mt-6" data-id="element-164" data-mp="2mvk5a6iayu6u">
          <CountdownTimer label="This offer ends in" note="Promotional price available for a limited time" data-id="element-165" data-mp="2mvtvnv79f3d2" />
        </div>

        <div className="mt-4" data-id="element-166" data-mp="2cvjmclocig36">
          <ScarcityBar data-id="element-167" data-mp="2cwuwd38dwk2q" />
        </div>

        <ul className="mt-6 grid grid-cols-2 gap-2" data-id="element-168" data-mp="65vgkbe29811">
          {badges.map(badge => <li key={badge} className="rounded-lg border border-white/10 bg-navy-900 px-2 py-2.5 text-center text-[12px] font-semibold leading-tight text-white/85 sm:text-sm" data-id="element-169" data-mp="b4zqx5cq1bsy">
              {badge}
            </li>)}
        </ul>

        <p className="mt-4 text-center text-[12px] font-medium text-white/60 sm:text-sm" data-id="element-170" data-mp="1qlup15w1gvc9">
          💱 Your currency is converted automatically based on your location.
        </p>
      </div>
    </header>;
}